import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageTitle, Card } from "./ui";
import { ShoppingBag, PoundSterling, MessageSquare, ClipboardList, Users, Send } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const COLORS = ["#D4AF37", "#F0D77B", "#8a7220", "#c9b15f"];

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);

  const cards = s ? [
    { label: "Total Orders", value: s.total_orders, icon: ShoppingBag, to: "/admin/orders" },
    { label: "Revenue", value: `£${s.revenue}`, icon: PoundSterling, to: "/admin/orders" },
    { label: "New Enquiries", value: s.new_enquiries, icon: MessageSquare, to: "/admin/enquiries" },
    { label: "Pending Questionnaires", value: s.pending_questionnaires, icon: ClipboardList, to: "/admin/orders" },
    { label: "Community Requests", value: s.community_requests, icon: Send, to: "/admin/enquiries" },
    { label: "Subscribers", value: s.subscribers, icon: Users, to: "/admin/subscribers" },
  ] : [];

  const statusData = s ? Object.entries(s.status_counts).map(([name, value]) => ({ name: name.replace("Questionnaire", "Q."), value })) : [];

  return (
    <>
      <PageTitle title="Dashboard" subtitle="Everything at a glance" />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <Link to={c.to} key={c.label}>
            <Card className="gold-glow-hover h-full">
              <div className="flex items-center justify-between">
                <div className="grid place-items-center h-10 w-10 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/30"><c.icon className="text-[#D4AF37]" size={18} /></div>
              </div>
              <div className="mt-4 text-2xl sm:text-3xl font-display gold-text">{c.value}</div>
              <div className="mt-1 text-xs text-white/50">{c.label}</div>
            </Card>
          </Link>
        ))}
      </div>

      <div className="mt-6 grid lg:grid-cols-2 gap-4">
        <Card>
          <h3 className="font-display text-lg mb-4">Orders by status</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={statusData}>
                <XAxis dataKey="name" tick={{ fill: "#888", fontSize: 11 }} />
                <YAxis tick={{ fill: "#888", fontSize: 11 }} allowDecimals={false} />
                <Tooltip contentStyle={{ background: "#111", border: "1px solid #333", borderRadius: 8, color: "#fff" }} />
                <Bar dataKey="value" fill="#D4AF37" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card>
          <h3 className="font-display text-lg mb-4">Revenue by product</h3>
          <div className="h-64">
            {s && s.by_product.length > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={s.by_product} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label={(e) => `£${e.value}`}>
                    {s.by_product.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                  </Pie>
                  <Tooltip contentStyle={{ background: "#111", border: "1px solid #333", borderRadius: 8, color: "#fff" }} />
                </PieChart>
              </ResponsiveContainer>
            ) : <div className="grid place-items-center h-full text-white/30 text-sm">No sales yet</div>}
          </div>
        </Card>
      </div>
    </>
  );
}
